/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePaymentTipRequest
 */
export interface UpdatePaymentTipRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePaymentTipRequest
     */
    paymentId: string;
    /**
     * 
     * @type {number}
     * @memberof UpdatePaymentTipRequest
     */
    tipAmount: number;
}

/**
 * Check if a given object implements the UpdatePaymentTipRequest interface.
 */
export function instanceOfUpdatePaymentTipRequest(value: object): value is UpdatePaymentTipRequest {
    if (!('paymentId' in value) || value['paymentId'] === undefined) return false;
    if (!('tipAmount' in value) || value['tipAmount'] === undefined) return false;
    return true;
}

export function UpdatePaymentTipRequestFromJSON(json: any): UpdatePaymentTipRequest {
    return UpdatePaymentTipRequestFromJSONTyped(json, false);
}

export function UpdatePaymentTipRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePaymentTipRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentId': json['paymentId'],
        'tipAmount': json['tipAmount'],
    };
}

export function UpdatePaymentTipRequestToJSON(json: any): UpdatePaymentTipRequest {
    return UpdatePaymentTipRequestToJSONTyped(json, false);
}

export function UpdatePaymentTipRequestToJSONTyped(value?: UpdatePaymentTipRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentId': value['paymentId'],
        'tipAmount': value['tipAmount'],
    };
}

